import { Button, Icon } from "@material-ui/core";
import React, { useState } from "react";
import colors, { colorsV2 } from "../../styles/colors";

import { IconButton } from "material-ui";
import "../../styles/rtm/PatientRTMRow.css";
import ActionButton from "../common/ActionButton";
import GenerateRTMDocumentation from "./GenerateRTMDocumentation";
import LogInterActionPopup from "./LogInteractionPopup";
import RTMBillingPopup from "./RTMBillingPopup";
import IconDelete from "material-ui/svg-icons/action/delete-forever";

export default (props) => {
  const [showInteractionPopup, setShowInteractionPopup] = useState(false);
  const [showReportPopup, setShowReportPopup] = useState(false);
  const [showBillingPopup, setShowBillingPopup] = useState(false);
  const padTo2Digits = (num) => {
    return num.toString().padStart(2, "0");
  };
  const formatDate = (dt) => {
    const date = new Date(dt);
    return [
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
      date.getFullYear(),
    ].join("/");
  };

  const olderThanSixteenDays = (date) => {
    const today = new Date();
    const priorDate = new Date(new Date().setDate(today.getDate() - 16));
    return new Date(date) < priorDate;
  };

  const getStatusForUser = () => {
    const five = getStatusForSevenFive();
    const seven = getStatusForSevenSeven();
    const zero = getStatusForEightOne();
    const one = getStatusForEightZero();
    return five || seven || zero || one;
  };

  const getStatusForSevenFive = () => {
    if (props.sevenFiveBilledFor) {
      return false;
    } else if (
      props.hasPatientActivity &&
      olderThanSixteenDays(props.dateOfEval)
    ) {
      return true;
    } else if (props.userInfo.profilePhotoUrl !== undefined) {
      // return "Call active patient - check in";
      return false;
    } else {
      // return "No Action Needed";
      return false;
    }
  };

  const getStatusForSevenSeven = () => {
    if (props.sevenSevenBilledFor) {
      return false;
    } else if (
      props.hasPatientActivity &&
      olderThanSixteenDays(props.dateOfEval)
    ) {
      return true;
    } else if (props.userInfo.profilePhotoUrl !== undefined) {
      // return "Call active patient - check in";
      return false;
    } else {
      // return "No Action Needed";
      return false;
    }
  };

  const getStatusForEightZero = () => {
    if (props.eightZeroBilledFor) {
      return false;
    } else if (props.minutesInChartThisMonth > 20) {
      return true;
    }

    return false;
  };

  const getStatusForEightOne = () => {
    if (props.eightOneBilledFor) {
      return false;
    } else if (props.minutesInChartThisMonth > 40) {
      return true;
    }

    return false;
  };

  return (
    <div className="patientRow">
      <div className="deleteIconRow">
        <IconButton
          onClick={() => {
            if (
              window.confirm(
                "Are you sure you want to remove this patient from RTM tracking?"
              )
            ) {
              props.removeRTMPatient();
            }
          }}
        >
          <IconDelete />
        </IconButton>
      </div>
      <div className="row">
        <div className="row">
          <div className="column">
            {props.userInfo && props.userInfo.profilePhotoUrl && (
              <img
                className="avatar"
                src={
                  props.userInfo && props.userInfo.profilePhotoUrl
                    ? props.userInfo.profilePhotoUrl
                    : null
                }
                alt="Patient Avatar"
                style={{ maxHeight: 100, maxWidth: 100 }}
              />
            )}
          </div>
          <div className="column">
            <ul className="patientInfoList">
              <li>
                <span className="patientName">
                  {props.userInfo.firstName ? props.userInfo.firstName : ""}{" "}
                  {props.userInfo.lastName ? props.userInfo.lastName : ""}
                </span>
              </li>
              <li>Reason For Treatment: {props.reasonForTreatment}</li>
              <li>Date Of Eval: {formatDate(props.dateOfEval)}</li>
              <li>Patient Phone: {props.patientPhone}</li>
              {props.matrixSize && (
                <li>TrabeculeX Matrix Size: {props.matrixSize}</li>
              )}
            </ul>
          </div>
        </div>
        <div className="column">
          <ul>
            <li
              style={{
                color: getStatusForSevenFive()
                  ? colorsV2.lightningYellow
                  : null,
              }}
            >
              98975 - Initial Setup & Patient Education{" "}
              {props.sevenFiveBilledFor ? " [Complete]" : ""}
            </li>
            <li
              style={{
                color: getStatusForSevenSeven()
                  ? colorsV2.lightningYellow
                  : null,
              }}
            >
              98977/989X6 - Supply And Use Of Device For Monitoring{" "}
              {props.sevenSevenBilledFor ? " [Complete]" : ""}
            </li>
            <li
              style={{
                color: getStatusForEightZero()
                  ? colorsV2.lightningYellow
                  : null,
              }}
            >
              98980 - Monitoring/Treatment Management Services, First 20 Minutes{" "}
              {props.eightZeroBilledFor ? " [Complete]" : ""}
            </li>
            <li
              style={{
                color: getStatusForEightOne() ? colorsV2.lightningYellow : null,
              }}
            >
              98981 - Monitoring/Treatment Management Services, Each Additional
              20 Minutes
              {props.eightOneBilledFor ? " [Complete]" : ""}
            </li>
          </ul>
        </div>
      </div>
      <div className="row end">
        <ActionButton
          label="Log Interaction"
          onClick={() => {
            setShowInteractionPopup(true);
          }}
          width={200}
        />
        <ActionButton
          label="Generate Claim"
          onClick={() => {
            setShowReportPopup(true);
          }}
          disabled={!getStatusForUser()}
        />
        <ActionButton
          label="Track Claim Submission"
          onClick={() => {
            setShowBillingPopup(true);
          }}
          disabled={!getStatusForUser()}
        />
      </div>
      <LogInterActionPopup
        showPopup={showInteractionPopup}
        setShowPopup={setShowInteractionPopup}
        customAppId={props.customAppId}
        patientUserId={props.patientUserId}
        providerUserId={props.providerUserId}
        updateRow={props.updateRow}
      />
      <GenerateRTMDocumentation
        showPopup={showReportPopup}
        setShowPopup={setShowReportPopup}
        customAppId={props.customAppId}
        patientUserId={props.patientUserId}
        providerUserId={props.providerUserId}
        dateOfEval={props.dateOfEval}
      />
      <RTMBillingPopup
        showPopup={showBillingPopup}
        setShowPopup={setShowBillingPopup}
        customAppId={props.customAppId}
        patientUserId={props.patientUserId}
        providerUserId={props.providerUserId}
        dateOfEval={props.dateOfEval}
        sevenFiveEnabled={getStatusForSevenFive()}
        sevenSevenEnabled={getStatusForSevenSeven()}
        eightZeroEnabled={getStatusForEightZero()}
        eightOneEnabled={getStatusForEightOne()}
        markBillingComplete={props.completeBilling}
        appId={props.appId}
        appInfo={props.appInfo}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/rtm/PatientRTMRow.js